import { useState } from 'react';
import { renderQuestions } from 'src/components/helpers/renderFormQuestions';
import { weddingFormCoupleQuestions } from '../questions/weddingFormCoupleQuestions';
import { errorInput, scrollUp } from 'src/components/helpers';
import { Message, Icon, Header, Button, Loader } from 'semantic-ui-react';

const StepFillCoupleData = (props) => {
  const { setStep, inputs, setInputs, directions, handleSubmit, loading, image, set_image } = props;
  const [errorInputs, setErrorInputs] = useState({});
  const [dateFocused, set_dateFocused] = useState(null);

  const questions = weddingFormCoupleQuestions(inputs?.coupleQuestions);

  const handleSetImage = (file) => {
    set_image(file);
    setErrorInputs((prev) => ({ ...prev, couple_picture: false }));
  };

  const handleInputs = (event) =>
    setInputs({
      ...inputs,
      coupleQuestions: {
        ...(inputs?.coupleQuestions || {}),
        [event.target.name]: event.target.value,
      },
    });

  const verifyForm = () => {
    let errorInputs = {};

    let mandatoryInputs = Object.values(questions)
      ?.map((a) => a.id)
      .filter((a) => !!a);

    mandatoryInputs.forEach((input) => {
      errorInputs = errorInput({
        errorInputs,
        input: { name: input, value: inputs?.coupleQuestions?.[input] },
      });
    });

    errorInputs = errorInput({
      errorInputs,
      input: {
        name: 'couple_picture',
        value: image,
      },
    });
    setErrorInputs(errorInputs);

    return Object.values({
      ...errorInputs,
    }).includes(true);
  };

  const changeStep = (e, direction) => {
    if (direction === 'prev') {
      setStep(directions?.prev);
    }
  };

  const handleFormSubmit = () => {
    if (verifyForm()) return scrollUp();
    handleSubmit();
  };

  return (
    <div className="read-doc-container">
      <div className="requirements-box">
        <Header as="h2" className="section-header">
          <Icon name="heart" />
          <Header.Content>
            Información de la Pareja
            <Header.Subheader>
              Por favor completa los datos adicionales de los dos.
            </Header.Subheader>
          </Header.Content>
        </Header>

        {Object.values(errorInputs).includes(true) && (
          <Message negative>
            <Message.Header>
              <Icon name="exclamation circle" /> Campos Requeridos
            </Message.Header>
            <p>Por favor completa todos los campos obligatorios antes de continuar.</p>
          </Message>
        )}

        <div className="form-section">
          {renderQuestions({
            questions,
            inputs: inputs?.coupleQuestions || {},
            changeStep,
            sending: loading,
            handleInputs,
            errorInputs,
            setErrorInputs,
            guests: { guest: inputs?.coupleQuestions },
            handleGuests: handleInputs,
            dateFocused,
            set_dateFocused,
            set_image: handleSetImage,
            image,
          })}
        </div>

        <div className="navigation-buttons">
          <Button secondary onClick={(e) => changeStep(e, 'prev')} disabled={loading}>
            <Icon name="arrow left" /> Anterior
          </Button>
          <Button primary onClick={handleFormSubmit} loading={loading} disabled={loading}>
            {loading ? (
              <>
                <Loader active inline size="small" />
                Enviando...
              </>
            ) : (
              <>
                Enviar Solicitud <Icon name="paper plane" />
              </>
            )}
          </Button>
        </div>

        {loading && (
          <Message info>
            <Message.Header>
              <Icon name="info circle" /> Procesando Solicitud
            </Message.Header>
            <p>
              Por favor espera mientras procesamos tu solicitud. Esto puede tomar unos momentos.
            </p>
          </Message>
        )}
      </div>
    </div>
  );
};

export default StepFillCoupleData;
